import {
  registerDecorator,
  type ValidationOptions,
  type ValidationArguments,
} from 'class-validator';
import { validateRgbaOrGradient } from './validateColor';

/**
 * Validates that a value is either:
 * 1. An RGBA object: { r: 0-255, g: 0-255, b: 0-255, a: 0-1 }
 * 2. A Gradient object: { type: 'Linear' | 'Radial', stops: [...], ... }
 */
export function IsColor(validationOptions?: ValidationOptions) {
  return function (object: object, propertyName: string) {
    registerDecorator({
      name: 'isRgbaOrGradient',
      target: object.constructor,
      propertyName: propertyName,
      options: validationOptions,
      validator: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        async validate(value: any) {
          if (value === null || value === undefined) {
            return false; // ColorDto.value is @IsDefined(), so null/undefined is invalid
          }

          return validateRgbaOrGradient(value);
        },
        defaultMessage(args: ValidationArguments) {
          return `${args.property} must be either a valid RGBA or Gradient object`;
        },
      },
    });
  };
}
